import { useFormik } from "formik";
import React, { useMemo } from "react";
import {
  PROJECT_ENQUIRY_REQUEST_FORM_FIELDS,
  PROJECT_ENQUIRY_REQUEST_FORM_INIT,
  PROJECT_ENQUIRY_REQUEST_FORM_VALIDATION_SCHEMA,
} from "./modules";
import {
  AREA_UNITS_OPTIONS,
  catchAsync,
  checkAnyFileToBeUpload,
  CI_PROJECT_CATEGORY_TYPE_OPTIONS,
  ENUM_CUSTOMER_TYPE_OPTIONS,
  FormField,
  RS_PROJECT_CATEGORY_TYPE_OPTIONS,
} from "src/helpers";
import RenderFormComponents from "src/shadcn/components/custom/RenderFormComponents";
import { Button } from "src/shadcn/components/ui";
import { useAuth } from "../Auth/Core";

type Props = {
  onSubmit: (e: any) => void;
};

const ProjectEnquiryRequestForm = ({ onSubmit }: Props) => {
  const { currentUser } = useAuth();

  const formik = useFormik({
    initialValues: PROJECT_ENQUIRY_REQUEST_FORM_INIT,
    validationSchema: PROJECT_ENQUIRY_REQUEST_FORM_VALIDATION_SCHEMA,
    onSubmit(values, formikHelpers) {
      handleToCheckAnyDocumentToBeUpload();
    },
  });

  const handleToCheckAnyDocumentToBeUpload = catchAsync(
    async () => {
      return await checkAnyFileToBeUpload(formik.values);
    },
    (result: any) => {
      if (result[1]) {
        onSubmit({ ...result[0], channelPartnerId: currentUser?.id || currentUser?.user_id });
      }
    },
    () => {}
  );

  const PROJECT_CATEGORY_TYPE_OPTIONS = useMemo(() => {
    if (
      [ENUM_CUSTOMER_TYPE_OPTIONS.Commercial, ENUM_CUSTOMER_TYPE_OPTIONS.Industrial].includes(
        formik.values.customerType
      )
    ) {
      return CI_PROJECT_CATEGORY_TYPE_OPTIONS;
    } else if (
      [ENUM_CUSTOMER_TYPE_OPTIONS.Residential, ENUM_CUSTOMER_TYPE_OPTIONS.Society].includes(formik.values.customerType)
    ) {
      return RS_PROJECT_CATEGORY_TYPE_OPTIONS;
    }
    return [];
  }, [formik.values.customerType]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid grid-cols-3 gap-4">
        {PROJECT_ENQUIRY_REQUEST_FORM_FIELDS.map((field: FormField) => {
          if (field?.dataKey === "projectCategoryType") {
            field = {
              ...field,
              componentProps: {
                ...field.componentProps,
                options: PROJECT_CATEGORY_TYPE_OPTIONS,
              },
            };
          }
          // else if (k == "channelPartnerId") {
          //     field = {
          //         ...field,
          //         componentProps: {
          //             ...field.componentProps,
          //             options: channelPartners
          //         }
          //     }
          // }
          else if (field?.dataKey === "projectSize" && formik.values.projectCategoryType === "Land for RE Projects") {
            field = {
              ...field,
              componentProps: {
                ...field.componentProps,
                type: "number",
                numberFormatted: true,
                options: AREA_UNITS_OPTIONS,
                defaultSelectedInputOption: "Acres",
              },
            };
          }

          if (["imageAttachments", "project_description"].includes(field.dataKey)) {
            return (
              <div className="col-span-3">
                <RenderFormComponents
                  key={`new-enquiry-form-${field.dataKey}`}
                  formik={formik}
                  value={formik.values[field.dataKey as keyof object]}
                  {...field}
                  onChange={(e: any) => formik.setFieldValue(field.dataKey, e)}
                />
              </div>
            );
          }
          return (
            <div>
              <RenderFormComponents
                key={`new-enquiry-form-${field.dataKey}`}
                formik={formik}
                value={formik.values[field.dataKey as keyof object]}
                {...field}
                onChange={(e: any) => formik.setFieldValue(field.dataKey, e)}
              />
            </div>
          );
        })}
      </div>
      <div className="py-4 flex justify-center">
        <Button className="w-[150px]">Submit</Button>
      </div>
    </form>
  );
};

export default ProjectEnquiryRequestForm;
